import { useFormikContext } from 'formik';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Switch from 'components/shared/Switch/Switch';

const StickyNotes = ({ practice, setPractice }) => {
  const { setFieldValue, values } = useFormikContext();

  const updateStickyNotification = async (data) => {
    const new_display_settings = {
      ...practice.display_settings,
      sticky_notes: {
        alert: data
      }
    };
    setPractice((prev) => ({ ...prev, display_settings: new_display_settings }));
    setFieldValue('displaySettings', new_display_settings);
  };

  return (
    <div className="flex w-full flex-col items-center justify-between gap-5 border-b border-l-0 border-r-0 border-t-0 border-solid border-b-neutral-100 pb-10 pt-5">
      <div className="flex w-full flex-col gap-5 text-sm">
        <span className="font-500">Sticky Notes</span>
      </div>
      <div className="flex w-full items-center gap-2">
        <Switch
          onChange={(e) => updateStickyNotification(e)}
          checked={values?.displaySettings?.sticky_notes?.alert}
        />
        <label className="block font-500">Sticky Notes Notification</label>
      </div>
    </div>
  );
};

export default withErrorBoundary(StickyNotes);
